export const GET_TARGETS_REQUEST = 'GET_TARGETS_REQUEST';
export const GET_TARGETS_SUCCESS = 'GET_TARGETS_SUCCESS';
export const GET_TARGETS_ERROR = 'GET_TARGETS_ERROR';
export const ADD_TARGET_REQUEST = 'ADD_TARGET_REQUEST';
export const ADD_TARGET_SUCCESS = 'ADD_TARGET_SUCCESS';
export const ADD_TARGET_ERROR = 'ADD_TARGET_ERROR';
export const UPDATE_TARGET_REQUEST = 'UPDATE_TARGET_REQUEST';
export const UPDATE_TARGET_SUCCESS = 'UPDATE_TARGET_SUCCESS';
export const UPDATE_TARGET_ERROR = 'UPDATE_TARGET_ERROR';
export const GET_TARGET_REQUEST = 'GET_TARGET_REQUEST';
export const GET_TARGET_SUCCESS = 'GET_TARGET_SUCCESS';
export const GET_TARGET_ERROR = 'GET_TARGET_ERROR';
export const GET_TARGET_INFO_REQUEST = 'GET_TARGET_INFO_REQUEST';
export const GET_TARGET_INFO_SUCCESS = 'GET_TARGET_INFO_SUCCESS';
export const GET_TARGET_INFO_ERROR = 'GET_TARGET_INFO_ERROR';
export const DELETE_TARGET_REQUEST = 'DELETE_TARGET_REQUEST';
export const DELETE_TARGET_SUCCESS = 'DELETE_TARGET_SUCCESS';
export const DELETE_TARGET_ERROR = 'DELETE_TARGET_ERROR';
export const DUPLICATE_TARGET_REQUEST = 'DUPLICATE_TARGET_REQUEST';
export const DUPLICATE_TARGET_SUCCESS = 'DUPLICATE_TARGET_SUCCESS';
export const DUPLICATE_TARGET_ERROR = 'DUPLICATE_TARGET_ERROR';
export const OPEN_DUPLICATE_TARGET_MODAL = 'OPEN_DUPLICATE_TARGET_MODAL';
export const CLOSE_DUPLICATE_TARGET_MODAL = 'CLOSE_DUPLICATE_TARGET_MODAL';
export const EMPTY_TARGET_INFO = 'EMPTY_TARGET_INFO';
export const GET_TARGET_TASK_ACTIONS_REQUEST =
  'GET_TARGET_TASK_ACTIONS_REQUEST';
export const GET_TARGET_TASK_ACTIONS_SUCCESS =
  'GET_TARGET_TASK_ACTIONS_SUCCESS';
export const GET_TARGET_TASK_ACTIONS_ERROR = 'GET_TARGET_TASK_ACTIONS_ERROR';
export const CLEAR_DEFAULT_TARGETS = 'CLEAR_DEFAULT_TARGETS';
